// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9bf82e4b","496":"a29b4634","653":"9f503f79"}[chunkId] + ".chunk.js";
};